export default {"src":"/_next/static/media/AboutYourself.36bd9b8a.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};